function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#A5ACB0",
  d: "M54 70H12V26h2v42h38v-8h2v10M52 34h2v-8h-2z"
}), React.createElement("path", {
  d: "M33 15c.153 0 .307.035.447.105L56 26.382v-2.764l-23-11.5-23 11.5v2.764l22.553-11.277c.14-.07.294-.105.447-.105zm24 14c-.153 0-.306-.035-.447-.105L33 17.118 9.447 28.895c-.31.154-.678.138-.973-.044A1.003 1.003 0 018 28v-5c0-.379.214-.725.553-.895l24-12c.281-.14.613-.14.894 0l24 12c.339.17.553.516.553.895v5a1.003 1.003 0 01-1 1z",
  fill: "#A5ACB0"
}), React.createElement("path", {
  d: "M33 27c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 10c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6zM23 47v-2h20v23h-2V47H25v21h-2V47z",
  fill: "#EA7125"
}), React.createElement("path", {
  fill: "#A5ACB0",
  d: "M18 19h-2v-9h6v7h-2v-5h-2v7M8 70h50v-2H8z"
}), React.createElement("path", {
  fill: "#A5ACB0",
  d: "M53 70h19v-2H53zM37 59h2v-2h-2z"
}), React.createElement("path", {
  fill: "#A5ACB0",
  d: "M59 69h2V43h-2z"
}), React.createElement("path", {
  d: "M60 37c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10zm0 22c-6.617 0-12-5.383-12-12s5.383-12 12-12 12 5.383 12 12-5.383 12-12 12z",
  fill: "#A5ACB0"
}), React.createElement("path", {
  fill: "#A5ACB0",
  d: "M59.293 50.707l-6-6 1.414-1.414 6 6-1.414 1.414M60.707 54.707l-1.414-1.414 6-6 1.414 1.414-6 6"
}), React.createElement("path", {
  d: "M0 0h80v80H0z"
}));

var SvgIconIllustrationHouse = function SvgIconIllustrationHouse(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80"
  }, props), _ref);
};

export default SvgIconIllustrationHouse;